import { useState } from "react";
import PropTypes from "prop-types";

const Accordion = ({ title, answer }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <div className="w-full font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary text-lg font-bold">
    <button 
  onClick={() => setAccordionOpen(!accordionOpen)} 
  className="grid grid-cols-[1fr_auto] items-start gap-4 w-full text-left"
>
  <span>{title}</span>
  <div className="flex items-center justify-center w-8 h-8">
    <svg
      className="fill-darkest dark:fill-primary transition-transform duration-200 ease-out"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{
        transform: accordionOpen ? "rotate(45deg)" : "rotate(0deg)",
      }}
    >
      <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  </div>
</button>


      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${accordionOpen ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="font-customFont1 text-left text-darkest dark:text-primary text-lg font-light mb-4">
          {answer}
        </div>
      </div>
    </div>
  );
};

// 🔧 Tämä tukee nyt myös JSX:ää
Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  answer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
};

export default Accordion;
